export const config = {
    notification: {
        people: [
        //     { type: "people-add", push: true, email: true },
        //     { type: "people-job", push: true, email: true },
        //     { type: "people-hire", push: true, email: true },
        //     { type: "people-compensation", push: true, email: true },
        //     { type: "people-organization", push: true, email: true },
        //     { type: "people-personal-information", push: true, email: true },
        //     { type: "people-company-information", push: true, email: true },
        //     { type: "people-address", push: true, email: true },
        //     { type: "people-management", push: true, email: true },
            { type: "license-expired", push: true, email: true },
            { type: "certification-expired", push: true, email: true }
        ],
        "timeclock": [
            {
                type: "employee-did-not-show-up",
                email: true,
                push: true,
                text: false,
                duration: false,
                day: false,
            },
            { type: "attestation-workflow", email: true, push: true },
        ],
        // request: [
        //     { type: 'employee-request-shift', email: true, push: true, text: false, duration: false, day: false },
        //     { type: 'employee-request-edit-shift', email: true, push: true, text: false, duration: false, day: false },
        //     { type: 'employee-request-edit-timesheet', email: true, push: true, text: false, duration: false, day: false },
        //     { type: 'employee-request-approve', email: true, push: true, text: false, duration: false, day: false },
        //     { type: 'employee-request-reject', email: true, push: true, text: false, duration: false, day: false },
        //     { type: 'employee-request-absence', email: true, push: true, text: false, duration: false, day: false },
        //     { type: 'employee-request-cancel', email: true, push: true, text: false, duration: false, day: false },
        //     { type: 'employee-request-schedule', email: true, push: true, text: false, duration: false, day: false },
        // ],
        "clock-exception": [
            {
                type: "came-early",
                email: true,
                push: true,
                text: false,
                duration: false,
                day: false,
            },
            {
                type: "came-late",
                email: true,
                push: true,
                text: false,
                duration: false,
                day: false,
            },
            {
                type: "left-early",
                email: true,
                push: true,
                text: false,
                duration: false,
                day: false,
            },
            {
                type: "left-late",
                email: true,
                push: true,
                text: false,
                duration: false,
                day: false,
            },
            {
                type: "daily-exception-report",
                email: true,
                push: true,
                text: false,
                duration: false,
                day: false,
            }
        ]
    },
    reminder: {
        timeclock: [
            {
                type: "near-start-of-shift",
                email: true,
                push: true,
                text: false,
                duration: true,
                day: false,
                info: "minutes-before-start-of-shift",
            },
            {
                type: "near-start-of-break",
                email: true,
                push: true,
                text: false,
                duration: true,
                day: false,
                info: "minutes-before-start-of-break",
            },
            {
                type: "near-end-of-break",
                email: true,
                push: true,
                text: false,
                duration: true,
                day: false,
                info: "minutes-before-end-of-break",
            },
            {
                type: "near-end-of-shift",
                email: true,
                push: true,
                text: false,
                duration: true,
                day: false,
                info: "minutes-before-end-of-shift",
            },
        ],
    },
    email: {
        timesheet: [
            {
                type: "daily-misspunch-report",
                email: true,
                push: false,
                text: false,
                // duration: true,
                duration: false,
                day: false,
            },
            {
                type: "weekly-misspunch-report",
                email: true,
                push: false,
                text: false,
                // duration: true,
                // day: true,
                duration: false,
                day: false,
            },
            {
                type: "daily-overtime-report",
                email: true,
                push: false,
                text: false,
                // duration: true,
                duration: false,
                day: false,
            },
            {
                type: "weekly-overtime-report",
                email: true,
                push: false,
                text: false,
                // duration: true,
                // day: true,
                duration: false,
                day: false,
            },
            {
                type: "daily-exception-report",
                email: true,
                push: false,
                text: false,
                // duration: true,
                duration: false,
                day: false,
            },
        ]
    },
};